import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AzavistaApiService, IEvent } from '@azavista/servicelib';
import { SharedService } from '../shared.service';
import { AzavistaInputFieldService } from '@azavista/components/input-field';

@Component({
    templateUrl: 'read-event-details.component.html',
    standalone: false
})
export class ReadEventDetailsComponent implements OnInit {
    start: string;
    end: string;

    constructor(
        public dialogRef: MatDialogRef<ReadEventDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IEvent,
        private sharedSvc: SharedService,
        private apiSvc: AzavistaApiService,
        private inputFieldSvc: AzavistaInputFieldService,
    ) {
    }

    ngOnInit(): void {
        this.start = this.formatDateWithEventTimezone(this.data?.start);
        this.end = this.formatDateWithEventTimezone(this.data?.end);
    }

    onOpenEvent(): void {
        this.dialogRef.close(true);
    }

    onClose(): void {
        this.dialogRef.close();
    }

    formatDateWithEventTimezone(dateString: string | undefined) {
        const currentUser = this.apiSvc.getCurrentUser();
        return this.inputFieldSvc.getDateWithTimezone(dateString, this.data.timezone, currentUser.datetime_format);
    }

}
